import { useNavigate } from 'react-router';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import { DrawerItem } from 'helpers/drawer-config';
import { useGlobalContext } from 'context/GlobalContext';

type DrawerMenuItemProps = {
  item: DrawerItem;
  open?: boolean;
  activeSubMenu?: boolean;
};

function DrawerMenuItem(props: DrawerMenuItemProps) {
  const { item } = props;
  const { hasPerm } = useGlobalContext();
  const navigate = useNavigate();

  if (!hasPerm(item.permissions)) {
    return null;
  }

  return (
    <ListItemButton
      disabled={item.disabled}
      onClick={
        item.url
          ? () => window.open(item.url, '_blank', 'noopener,noreferrer')
          : () => navigate(item.path)
      }
      style={
        item.activeSubMenu
          ? { background: '#122D58' }
          : { background: '#09172E' }
      }
    >
      <ListItemText
        primary={item.title}
        sx={{
          whiteSpace: 'normal'
        }}
      />
    </ListItemButton>
  );
}

export default DrawerMenuItem;
